import builder from '../builder';
import ArrowUp1 from '../../streamline-icons/light/arrow-up-1.svg';

export default builder('IconArrowUp1Light', ArrowUp1);
